import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.replace";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useContext, useEffect, useState } from 'react';
import { AnalyticsContext } from '@nerdwallet/analytics/react';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';

var useCallbackChain = function useCallbackChain(method, callback) {
  return useCallback(function () {
    method.apply(void 0, arguments);
    if (callback) callback.apply(void 0, arguments);
  }, [method, callback]);
};

var buildEntityName = function buildEntityName(entityName) {
  return entityName.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};

var useElementInteraction = function useElementInteraction(_ref) {
  var _ref$enable = _ref.enable,
      enable = _ref$enable === void 0 ? true : _ref$enable,
      visible = _ref.visible,
      entityName = _ref.entityName,
      onClickProp = _ref.onClick,
      onFocusProp = _ref.onFocus,
      onBlurProp = _ref.onBlur;
  var analytics = useContext(AnalyticsContext);
  var impressionContext = useContext(ImpressionContext);
  var impressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId; // stores last interaction type

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      prevInteractionType = _useState2[0],
      setPrevInteractionType = _useState2[1]; // updates the interactionType whenever user interacts with interface


  var updateInteractionType = useCallback(function (interactionType) {
    // update interaction type in state, waiting until visibility change to fire event
    setPrevInteractionType(interactionType);
  }, []); // wait for change to `visible` prop to fire events

  var _useState3 = useState(visible),
      _useState4 = _slicedToArray(_useState3, 2),
      prevVisible = _useState4[0],
      setPrevVisible = _useState4[1];

  useEffect(function () {
    if (!enable) return undefined; // bail if visibility value hasn't changed

    if (visible === prevVisible) return undefined; // immediately update prev visible state

    setPrevVisible(visible); // fire the event

    var payload = {
      action: visible ? 'open' : 'close',
      entity_name: buildEntityName(entityName),
      interaction_type: prevInteractionType,
      impression_id: impressionId
    };
    analytics.track('element_interacted', payload);
    return undefined;
  }, [enable, visible, prevVisible, prevInteractionType, entityName, analytics, impressionId]); // spread the output of this hook on the target component

  return {
    onClick: useCallbackChain(function () {
      return updateInteractionType('press');
    }, onClickProp),
    onFocus: useCallbackChain(function () {
      return updateInteractionType('focus');
    }, onFocusProp),
    onBlur: useCallbackChain(function () {
      return updateInteractionType('blur');
    }, onBlurProp) // not attaching mouseover or mouseout, this component has no hoverability
    // not attaching onKeydown, because reakit uses keydown binding to fire click events, so the click follows the keydown, so interactionType is always 'click'

  };
};

export default useElementInteraction;